import { UiBadgeVariant } from './ui-badge.model';

export type UiTableCellType = 'text' | 'link' | 'badge' | 'actions' | 'date' | 'checkbox';

export interface UiTableColumn {
  key: string;
  label: string;
  type?: UiTableCellType;
  sortable?: boolean;
  width?: string;
  badgeKey?: string;
}

export interface UiToolbarAction {
  id: string;
  label: string;
  icon?: string;
  variant?: 'primary' | 'outline' | 'ghost' | 'success';
  disabled?: boolean;
  visible?: boolean;
}

export type UiTableActionType =
  | 'view'
  | 'edit'
  | 'more'
  | 'delete'
  | 'docs'
  | 'reopen'
  | 'cancel-approval'
  | 'expand'
  | 'collapse';

export interface UiTableAction {
  type: UiTableActionType | string;
  visible?: boolean;
  disabled?: boolean;
}

export interface UiFilterOption {
  label: string;
  value: string;
}

export interface UiTableFilter {
  key: string;
  label: string;
  options: UiFilterOption[];
  value: string;
  showIcon?: boolean;
}

export function getBadgeVariantForStatus(status: string): UiBadgeVariant {
  const normalized = (status || '').toLowerCase();
  if (normalized === 'approved') return 'approved';
  if (normalized === 'pending') return 'pending';
  if (normalized === 'rejected') return 'rejected';
  if (normalized === 'open') return 'default';
  return 'default';
}

export function getBadgeVariantForType(type: string): UiBadgeVariant {
  const normalized = (type || '').toLowerCase();
  if (normalized.includes('service')) return 'services';
  if (normalized.includes('goods')) return 'goods';
  if (normalized.includes('fixed')) return 'fixed-asset';
  return 'default';
}
